import styled from 'styled-components';
export var Container = styled.nav.withConfig({
  displayName: "Categoriesstyles__Container",
  componentId: "sc-x478rz-0"
})(["box-sizing:border-box;max-width:1012px;margin:0 auto;padding:16px;"]);
export var List = styled.ul.withConfig({
  displayName: "Categoriesstyles__List",
  componentId: "sc-x478rz-1"
})(["columns:4;"]);
export var ListItem = styled.li.withConfig({
  displayName: "Categoriesstyles__ListItem",
  componentId: "sc-x478rz-2"
})(["padding-bottom:12px;break-inside:avoid;"]);
//# sourceMappingURL=Categories.styles.js.map